import React from 'react';
import SmartDialog from "../SmartDialog";
import moment from 'moment';
import {ExpanderView, LevelBadge, SectionedList, TextField} from "./Elements";
import StandardValue from "../../common/StandardValue";
import Utils from "../../common/Utils";

class AuditDetailsDialog extends React.Component {

    constructor(props){
        super(props);
        this.state = AuditDetailsDialog.getInitialState({});
    }

    static getInitialState({ item }){

        return {
            item: item || null
        };

    }

    show(record){

        this.setState(AuditDetailsDialog.getInitialState({ item: record }), () => {
            this._dlg.show();
        });

    }

    render(){

        const { item } = this.state;
        return <SmartDialog ref={r => this._dlg = r} title="Audit Record Details">

            {item && <div className="mb-2">

                <ExpanderView title={"Detail"} isExpanded className="mb-2">
                    <SectionedList items={[
                        {
                            title: 'Level',
                            value: <LevelBadge style={{ display: "inline" }} level={item.level}/>
                        },
                        {
                            title: 'Message',
                            value: item.message,
                            mode: "vertical"
                        },
                        {
                            title: 'Action',
                            value: item.action
                        },
                        {
                            title: 'Timestamp',
                            value: moment(item.timestamp).format('l hh:mm:ss')
                        }
                    ]}/>
                </ExpanderView>

                {item.model && <ExpanderView title={`Model (${Utils.ucFirst(item.model_type)})`} className="mb-2">
                    <TextField text={JSON.stringify(item.model)}/>
                </ExpanderView>}

                {(item.user && Object.keys(item.user).length > 0) && <ExpanderView title={"User"} className="mb-2">
                    <SectionedList items={[
                        {
                            title: 'Username',
                            value: item.user.username
                        },
                        {
                            title: 'Email',
                            value: <StandardValue value={item.user.email}/>
                        },
                        {
                            title: 'Phone',
                            value: <StandardValue value={item.user.phone}/>
                        },
                        {
                            title: 'Account Type',
                            value: item.user.user_role
                        }
                    ]}/>
                </ExpanderView>}


                {item.metadata && <ExpanderView title={"Metadata"} className="mb-2">
                    <TextField text={item.metadata}/>
                </ExpanderView>}

            </div>}

        </SmartDialog>

    }

}

export default AuditDetailsDialog;


// WEBPACK FOOTER //
// ./src/components/AuditExplorer/AuditDetailsDialog.js